import { createContext, useContext } from "react";

// Lets any admin tab drill across the section:
//  - openReceipts(filter): jump to the Slips tab pre-filtered
//  - openUser(userId): jump to the Users tab and open that user's detail popup
//  - goTab(tab): switch to any admin tab
export const AdminNavContext = createContext({ openReceipts: () => {}, openUser: () => {}, goTab: () => {} });
export const useAdminNav = () => useContext(AdminNavContext);
